const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.UserServiceSimpleClient = function UserServiceSimpleClient(
  hostname,
  credentials,
  options
) {
  if (!options) options = {};
  options["format"] = "text";

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  this.hostname_ = hostname;
  this.credentials_ = credentials;
  this.options_ = options;

  this.findOrCreateUser = this.findOrCreateUser.bind(this);
  this.grantDeveloperAccess = this.grantDeveloperAccess.bind(this);
  this.assignRole = this.assignRole.bind(this);
  this.removeRole = this.removeRole.bind(this);
  this.getUser = this.getUser.bind(this);
  this.updateUserPreferences = this.updateUserPreferences.bind(this);
  this.editUser = this.editUser.bind(this);
  this.deleteUser = this.deleteUser.bind(this);
  this.listUsers = this.listUsers.bind(this);
  this.listUserRoles = this.listUserRoles.bind(this);
  this.getUserRoleRequest = this.getUserRoleRequest.bind(this);
  this.createUserRoleRequest = this.createUserRoleRequest.bind(this);
  this.listUserRoleRequests = this.listUserRoleRequests.bind(this);
  this.approveUserRoleRequest = this.approveUserRoleRequest.bind(this);
  this.rejectUserRoleRequest = this.rejectUserRoleRequest.bind(this);
  this.deleteUserRoleRequest = this.deleteUserRoleRequest.bind(this);
  this.triggerPageLocker = this.triggerPageLocker.bind(this);
  this.releasePageLocker = this.releasePageLocker.bind(this);
  this.pullPageLocker = this.pullPageLocker.bind(this);
};
const methodInfo_UserService_FindOrCreateUser = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/FindOrCreateUser",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.FindOrCreateUserRequest,
  imports.stronachgroup.first.racehorse360.AuthUser,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.AuthUser.decode
);
module.exports.UserServiceSimpleClient.prototype.findOrCreateUser = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.FindOrCreateUserRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.UserService/FindOrCreateUser",
    message,
    metadata || {},
    methodInfo_UserService_FindOrCreateUser
  );
};
const methodInfo_UserService_GrantDeveloperAccess =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/GrantDeveloperAccess",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest,
    imports.stronachgroup.first.racehorse360.User,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.User.decode
  );
module.exports.UserServiceSimpleClient.prototype.grantDeveloperAccess =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GrantDeveloperAccessRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/GrantDeveloperAccess",
      message,
      metadata || {},
      methodInfo_UserService_GrantDeveloperAccess
    );
  };
const methodInfo_UserService_AssignRole = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/AssignRole",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.AssignRoleRequest,
  imports.stronachgroup.first.racehorse360.User,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.User.decode
);
module.exports.UserServiceSimpleClient.prototype.assignRole = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.AssignRoleRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.racehorse360.UserService/AssignRole",
    message,
    metadata || {},
    methodInfo_UserService_AssignRole
  );
};
const methodInfo_UserService_RemoveRole = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/RemoveRole",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.RemoveRoleRequest,
  imports.stronachgroup.first.racehorse360.User,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.User.decode
);
module.exports.UserServiceSimpleClient.prototype.removeRole = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.RemoveRoleRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.racehorse360.UserService/RemoveRole",
    message,
    metadata || {},
    methodInfo_UserService_RemoveRole
  );
};
const methodInfo_UserService_GetUser = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/GetUser",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.GetUserRequest,
  imports.stronachgroup.first.racehorse360.User,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.User.decode
);
module.exports.UserServiceSimpleClient.prototype.getUser = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.GetUserRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.racehorse360.UserService/GetUser",
    message,
    metadata || {},
    methodInfo_UserService_GetUser
  );
};
const methodInfo_UserService_UpdateUserPreferences =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/UpdateUserPreferences",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UpdateUserPreferencesRequest,
    imports.stronachgroup.first.racehorse360.UserPreferences,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UserPreferences.decode
  );
module.exports.UserServiceSimpleClient.prototype.updateUserPreferences =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UpdateUserPreferencesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/UpdateUserPreferences",
      message,
      metadata || {},
      methodInfo_UserService_UpdateUserPreferences
    );
  };
const methodInfo_UserService_EditUser = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/EditUser",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.EditUserRequest,
  imports.stronachgroup.first.racehorse360.User,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.User.decode
);
module.exports.UserServiceSimpleClient.prototype.editUser = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.EditUserRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.racehorse360.UserService/EditUser",
    message,
    metadata || {},
    methodInfo_UserService_EditUser
  );
};
const methodInfo_UserService_DeleteUser = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/DeleteUser",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.DeleteUserRequest,
  imports.stronachgroup.first.racehorse360.EmptyResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.EmptyResponse.decode
);
module.exports.UserServiceSimpleClient.prototype.deleteUser = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.DeleteUserRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.racehorse360.UserService/DeleteUser",
    message,
    metadata || {},
    methodInfo_UserService_DeleteUser
  );
};
const methodInfo_UserService_ListUsers = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/ListUsers",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListUserRequest,
  imports.stronachgroup.first.racehorse360.ListUserResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListUserResponse.decode
);
module.exports.UserServiceSimpleClient.prototype.listUsers = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListUserRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.racehorse360.UserService/ListUsers",
    message,
    metadata || {},
    methodInfo_UserService_ListUsers
  );
};
const methodInfo_UserService_ListUserRoles = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/ListUserRoles",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListUserRolesRequest,
  imports.stronachgroup.first.racehorse360.ListUserRolesResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListUserRolesResponse.decode
);
module.exports.UserServiceSimpleClient.prototype.listUserRoles = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListUserRolesRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.UserService/ListUserRoles",
    message,
    metadata || {},
    methodInfo_UserService_ListUserRoles
  );
};
const methodInfo_UserService_GetUserRoleRequest = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/GetUserRoleRequest",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.GetUserRoleRequestRequest,
  imports.stronachgroup.first.racehorse360.UserRoleRequest,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.UserRoleRequest.decode
);
module.exports.UserServiceSimpleClient.prototype.getUserRoleRequest = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.GetUserRoleRequestRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.UserService/GetUserRoleRequest",
    message,
    metadata || {},
    methodInfo_UserService_GetUserRoleRequest
  );
};
const methodInfo_UserService_CreateUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/CreateUserRoleRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateUserRoleRequestRequest,
    imports.stronachgroup.first.racehorse360.UserRoleRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UserRoleRequest.decode
  );
module.exports.UserServiceSimpleClient.prototype.createUserRoleRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateUserRoleRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/CreateUserRoleRequest",
      message,
      metadata || {},
      methodInfo_UserService_CreateUserRoleRequest
    );
  };
const methodInfo_UserService_ListUserRoleRequests =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/ListUserRoleRequests",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest,
    imports.stronachgroup.first.racehorse360.ListUserRoleRequestsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListUserRoleRequestsResponse.decode
  );
module.exports.UserServiceSimpleClient.prototype.listUserRoleRequests =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListUserRoleRequestsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ListUserRoleRequests",
      message,
      metadata || {},
      methodInfo_UserService_ListUserRoleRequests
    );
  };
const methodInfo_UserService_ApproveUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/ApproveUserRoleRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest,
    imports.stronachgroup.first.racehorse360.UserRoleRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UserRoleRequest.decode
  );
module.exports.UserServiceSimpleClient.prototype.approveUserRoleRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ApproveUserRoleRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/ApproveUserRoleRequest",
      message,
      metadata || {},
      methodInfo_UserService_ApproveUserRoleRequest
    );
  };
const methodInfo_UserService_RejectUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/RejectUserRoleRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.RejectUserRoleRequestRequest,
    imports.stronachgroup.first.racehorse360.UserRoleRequest,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.UserRoleRequest.decode
  );
module.exports.UserServiceSimpleClient.prototype.rejectUserRoleRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.RejectUserRoleRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/RejectUserRoleRequest",
      message,
      metadata || {},
      methodInfo_UserService_RejectUserRoleRequest
    );
  };
const methodInfo_UserService_DeleteUserRoleRequest =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.UserService/DeleteUserRoleRequest",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.UserServiceSimpleClient.prototype.deleteUserRoleRequest =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteUserRoleRequestRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.UserService/DeleteUserRoleRequest",
      message,
      metadata || {},
      methodInfo_UserService_DeleteUserRoleRequest
    );
  };
const methodInfo_UserService_TriggerPageLocker = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/TriggerPageLocker",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.PageLockerRequest,
  imports.stronachgroup.first.racehorse360.TriggerPageLockerResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.TriggerPageLockerResponse.decode
);
module.exports.UserServiceSimpleClient.prototype.triggerPageLocker = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.PageLockerRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.UserService/TriggerPageLocker",
    message,
    metadata || {},
    methodInfo_UserService_TriggerPageLocker
  );
};
const methodInfo_UserService_ReleasePageLocker = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/ReleasePageLocker",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.PageLockerRequest,
  imports.stronachgroup.first.racehorse360.EmptyResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.EmptyResponse.decode
);
module.exports.UserServiceSimpleClient.prototype.releasePageLocker = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.PageLockerRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.UserService/ReleasePageLocker",
    message,
    metadata || {},
    methodInfo_UserService_ReleasePageLocker
  );
};
const methodInfo_UserService_PullPageLocker = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.UserService/PullPageLocker",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.PageLockerRequest,
  imports.stronachgroup.first.racehorse360.PullPageLockerResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.PullPageLockerResponse.decode
);
module.exports.UserServiceSimpleClient.prototype.pullPageLocker = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.PageLockerRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.UserService/PullPageLocker",
    message,
    metadata || {},
    methodInfo_UserService_PullPageLocker
  );
};
